module.exports = __webpack_public_path__ + "static/media/trash_can_white.03d46bc9.svg";